import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
export default function DataPreviewEnchancedSupport(_ref) {
  let {
    aifReportData
  } = _ref;
  const {
    aif_model
  } = aifReportData;
  const formatCurrency = amount => {
    if (!amount) return '£0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numAmount);
  };
  const formatDate = dateString => {
    return new Date(dateString).toLocaleDateString('en-GB');
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-white",
    style: {
      backgroundColor: '#6f42c1'
    }
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Enhanced Support")), /*#__PURE__*/React.createElement(Card.Body, null, aif_model.enhanced_support_by_accounting_period.map((period, index) => /*#__PURE__*/React.createElement("div", {
    key: index
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Accounting Period: ", formatDate(period.accounting_period.start), " - ", formatDate(period.accounting_period.end)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Has Supporting Evidence:"), " ", /*#__PURE__*/React.createElement(Badge, {
    bg: period.has_supporting_evidence ? 'success' : 'danger'
  }, period.has_supporting_evidence ? 'Yes' : 'No')), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Has Connected Companies:"), " ", /*#__PURE__*/React.createElement(Badge, {
    bg: period.has_connected_companies ? 'warning' : 'success'
  }, period.has_connected_companies ? 'Yes' : 'No'))), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Trading & Operating Expenses:"), " ", formatCurrency(period.trading_and_operating_expenses)), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Section 1308 Adjustment:"), " ", formatCurrency(period.section1308_adjustment))))))));
}